import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { encryptionDetailLive } from "@/api/php/player";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
interface dataProps {
  roomdata: any;
  type: any
}

export default /*#__PURE__*/_defineComponent({
  name: 'TeamBasketball',
  props: {
    roomdata: { type: null, required: true },
    type: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  roomdata: any;
  type: any
}

const { t } = useI18n()
const route = useRoute();
let team1 = ref("");
let team2 = ref("");
let homePlayers = ref();
let awayPlayers = ref();
let tbname = [
  t('play.number'),
  t('play.teamUser'),
  t('play.starter'),
  t('play.time'),
  t('play.score'),
  t('play.lb'),
  t('play.zg'),
  t('play.tl'),
  t('play.sanfen'),
  t('play.fq'),
  t('play.qd'),
  t('play.qb'),
  t('play.hb'),
  t('play.gm'),
  t('play.sw'),
  t('play.fg'),
  "+/-",
];



onMounted(() => {
  getData();
  teamname();
});

const getData = async () => {
  let { matchType, matchId } = route.query;
  if (
    matchId == "" ||
    matchId == null ||
    matchId == undefined ||
    matchId == "0"
  ) {
    matchId = props.roomdata.match_id;
  }
  if (
    matchType == "" ||
    matchType == null ||
    matchType == undefined ||
    matchType == "0"
  ) {
    if (props.roomdata.type_id) {
      matchType = props.roomdata.type_id
    } else {
      matchType = props.roomdata.match_type;
    }
  }

  if (
    matchType != "" &&
    matchType != null &&
    matchType != undefined &&
    matchId != "" &&
    matchId != null &&
    matchId != undefined
  ) {
    const res: any = await encryptionDetailLive({
      type_id: matchType,
      match_id: matchId,
    });
    if (res.code == 200) {

      let data = [];
      if (res.data.players && res.data.players.length > 0) {
        let players = res.data.players;
        for (let i = 0; i < players.length && i < 2; i++) {
          let tmp = [];
          for (let j = 0; j < players[i].length; j++) {
            const element = players[i][j];
            const pdata = element[6].split("^");
            let obj = {
              id: element[0],
              numbers: element[5],
              name: element[1],
              start: pdata[16],
              duration: pdata[0],
              goal: pdata[13],
              backboard: pdata[6],
              assist: pdata[7],
              shot: pdata[1],
              threePointer: pdata[2],
              freeShot: pdata[3],
              snatch: pdata[8],
              frontPlate: pdata[4],
              backPlate: pdata[5],
              blockShots: pdata[9],
              miss: pdata[10],
              foul: pdata[11],
              jiajian: pdata[12],
            };
            tmp.push(obj);
          }
          data.push(tmp);
        }
        homePlayers.value = data[0];
        awayPlayers.value = data[1];
      }
    }
  }
};

const teamname = async () => {
  // 队伍名称1
  if (
    props.roomdata &&
    props.roomdata.home_name != "" &&
    props.roomdata.home_name != null &&
    props.roomdata.home_name != undefined
  ) {
    team1.value = props.roomdata.home_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team1.value = arr[0];
  }
  // 队伍名称2
  if (
    props.roomdata &&
    props.roomdata.away_name != "" &&
    props.roomdata.away_name != null &&
    props.roomdata.away_name != undefined
  ) {
    team2.value = props.roomdata.away_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team2.value = arr[1];
  }
};

const __returned__ = { t, route, team1, team2, homePlayers, awayPlayers, tbname, props, getData, teamname }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})